import type { AcuityHistoryResponse, UUID } from "@/core/types";
import { acuityRequestsTyped } from "@/APIRequests/acuityTyped";

export async function getAcuityHistory(patientId: UUID): Promise<AcuityHistoryResponse> {
  return acuityRequestsTyped.get_acuity_history({ params: { showLoader: false }, patientId });
}
